<template><App :keepAliveInclude="keepAliveInclude"/></template><script lang="ts">
    import Vue from 'vue';
import { getCurrentPlatform } from './utils/platform';
    export default Vue.extend({
        mpType: 'app',
        onLaunch() {
            console.log('App Launch');
            // 取消注释，启用登录状态检查
            this.checkLoginStatus();
        },
        onShow() {
            console.log('App Show');
        },
        onHide() {
            console.log('App Hide');
        },
        methods: {
            // 检查登录状态（仅Web端执行）
            checkLoginStatus() {
                try {
                    
                    // 仅在Web端(h5)执行登录校验，小程序端跳过
                    if (getCurrentPlatform() !== 'web') {
                        console.log('小程序端不执行登录校验');
                        return;
                    }
                    
                    // Web端执行登录校验逻辑
                    const hasLogin = uni.getStorageSync('hasLogin');
                    const currentPages = getCurrentPages();
                    const currentPath = currentPages[0]?.route ?? '';
                    
                    console.log('Web端登录状态检查:', { hasLogin, currentPath });
                    
                    // 如果未登录且当前页面不是登录页，则重定向到登录页
                    if (!hasLogin && !currentPath.includes('login')) {
                        console.log('Web端未登录，重定向到登录页');
                        uni.redirectTo({
                            url: '/pages/login/index',
                            success: () => console.log('重定向到登录页成功'),
                            fail: (err) => console.error('重定向到登录页失败:', err)
                        });
                    }
                } catch (error) {
                    console.error('登录状态检查失败:', error);
                }
            }
        }
    });
</script>

<style>
    /*每个页面公共css */
    view{  
    user-select: text;  
    }  
</style>